import { RootState } from 'store';
import { useSelector } from 'react-redux';
import { checkIsLoading } from 'common/utils/checkLoading';

import { DRIVERS_STATE } from '../../constants';

export const useDriverFuelAssignments = () => {
  const driverFuelAssignments = useSelector((state: RootState) => state[DRIVERS_STATE].fuelAssignments.data);
  return driverFuelAssignments;
};

export const useDriverFuelAssignmentsPaging = () => {
  const driverFuelAssignmentsPaging = useSelector((state: RootState) => state[DRIVERS_STATE].fuelAssignments.paging);
  return driverFuelAssignmentsPaging;
};

const useDriverFuelAssignmentsLoadingStatus = () => {
  const driverFuelAssignmentsLoadingStatus = useSelector((state: RootState) => state[DRIVERS_STATE].fuelAssignments.loadingStatus);
  return driverFuelAssignmentsLoadingStatus;
};

export const useIsDriverFuelAssignmentsLoading = () => {
  const driverFuelAssignmentsLoadingStatus = useDriverFuelAssignmentsLoadingStatus();
  return checkIsLoading(driverFuelAssignmentsLoadingStatus);
};
